import React, { ReactNode, useState } from "react";
import { ManageFields, ManageSectionsModals } from "../../../../types/enums";
import { ConfigSectionModal, ManageSectionsModal } from "../../modal";

export const ManageSectionsBtn = ({
  campaign_id,
  customButton,
}: {
  campaign_id: string;
  customButton: (onClick: () => void) => ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [currentModal, setCurrentModal] = useState<ManageSectionsModals>(
    ManageSectionsModals.none,
  );

  const onBackHandler = () => {
    setCurrentModal(ManageSectionsModals.none);
  };

  const onCloseHandler = () => {
    setCurrentModal(ManageSectionsModals.none);
    setIsOpen(false);
  };

  const modals: Record<ManageSectionsModals, ReactNode> = {
    [ManageSectionsModals.account_plan]: (
      <ConfigSectionModal
        type={ManageFields.account_plan_fields}
        onClose={onCloseHandler}
        onBack={onBackHandler}
        campaign_id={campaign_id}
      />
    ),
    [ManageSectionsModals.playbook]: (
      <ConfigSectionModal
        type={ManageFields.sdr_playbook_fields}
        onClose={onCloseHandler}
        onBack={onBackHandler}
        campaign_id={campaign_id}
      />
    ),
    [ManageSectionsModals.none]: null,
  };

  return (
    <>
      {customButton(() => setIsOpen(true))}
      {isOpen && (
        <ManageSectionsModal
          onClose={onCloseHandler}
          onBack={onCloseHandler}
          setCurrentModalHandler={setCurrentModal}
          isHide={!!currentModal}
        />
      )}
      {modals[currentModal]}
    </>
  );
};
